import * as React from 'react';
import cn from '~modules/cn';
import './input.scss';

type InputProps = {
    status?: 'error' | 'success';
};

export type Props = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & InputProps;

export const Input = React.forwardRef<HTMLInputElement, Props>((props, ref): JSX.Element => {
    const { status, className, ...rest } = {
        ...props
    } as Props;

    return (
        <input
            {...rest}
            ref={ref}
            className={cn('input', className, {
                [`input--${status}`]: status
            })}
        />
    );
});

Input.displayName = 'Input';

export default Input;
